import { Stack, Typography } from "@mui/material";
import type { MetadataChange } from "../../utils/llmClassifierVersionComparison";

export function MetadataChangeRows(props: { changes: MetadataChange[] }) {
    if (props.changes.length === 0) return null;

    return (
        <Stack gap={1}>
            {props.changes.map((change) => (
                <Stack
                    key={change.key}
                    direction="row"
                    alignItems="center"
                    gap={1}
                    flexWrap="wrap"
                >
                    <Typography
                        color="gray.700"
                        variant="body2"
                        fontWeight={600}
                        minWidth={140}
                    >
                        {change.label}
                    </Typography>
                    <ValueChip value={change.before} tone="removed" />
                    <Typography color="gray.500">→</Typography>
                    <ValueChip value={change.after} tone="added" />
                </Stack>
            ))}
        </Stack>
    );
}

function ValueChip(props: { value: string; tone: "added" | "removed" }) {
    const added = props.tone === "added";

    return (
        <Typography
            variant="body2"
            px={1}
            borderRadius={1}
            sx={(theme) => ({
                color: added
                    ? theme.palette.green.main
                    : theme.palette.error[700],
                backgroundColor: added
                    ? theme.palette.green.background
                    : theme.palette.error[100],
                textDecoration: added ? "none" : "line-through",
                overflowWrap: "anywhere",
            })}
        >
            {props.value}
        </Typography>
    );
}
